<template>
  <div>
    <transition name="fade">
      <div v-if="show" class="filter-overlay" @click="$emit('update:show', false)"></div>
    </transition>
    <transition name="slide-fade">
      <div v-if="show" class="filter-drawer">
        <div class="filter-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0 font-weight-bold">{{ title }}</h5>
          <button class="close-btn" @click="$emit('update:show', false)">
            <X :size="24" />
          </button>
        </div>
        <div class="filter-content">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { X } from 'lucide-vue';

// Von rechts einblendendes Filterpanel mit Overlay, Inhalt kommt über den Default-Slot
export default {
  name: 'FilterDrawer',
  components: { X },
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Filter' },
  },
};
</script>

<style scoped>
.filter-drawer {
  position: fixed;
  top: 120px;
  right: 17px;
  width: 342px;
  max-height: calc(100vh - 140px);
  background: var(--surface);
  border-radius: 12px;
  box-shadow: 0px 4px 9px 0px #98a0b440;
  display: flex;
  flex-direction: column;
  z-index: 1052;
}

.filter-header {
  padding: 16px 16px 0px 16px;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #666;
}

.filter-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1051;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
